import { MessageCircle } from "lucide-react";

const WA_URL =
  "https://wa.me/917006676788?text=" +
  encodeURIComponent("Hi KR Studio! I'd like to talk about a project.");

export const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-fab"
    aria-label="Chat with KR Studio on WhatsApp"
    data-testid="whatsapp-fab"
  >
    <MessageCircle size={24} fill="currentColor" strokeWidth={0} />
  </a>
);
